<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1 class="text-h4 mb-4">Ρυθμίσεις</h1>
      </v-col>
    </v-row>

    <v-row>
      <!-- Company -->
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-card link :to="{ name: 'company' }" :disabled="subscriptionExpired" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-domain</v-icon>
            <div class="text-h6">Εταιρία</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Document Types -->
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-card link :to="{ name: 'documenttypes' }" :disabled="subscriptionExpired" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-file</v-icon>
            <div class="text-h6">Παραστατικά</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Charge Types -->
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-card link :to="{ name: 'chargetypes' }" :disabled="subscriptionExpired" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-playlist-plus</v-icon>
            <div class="text-h6">Χρεώσεις</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Vehicles -->
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-card link :to="{ name: 'vehicles' }" :disabled="subscriptionExpired" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-truck</v-icon>
            <div class="text-h6">Οχήματα</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Packages (Transportation Features) -->
      <v-col cols="12" sm="6" md="4" lg="3" v-if="showTransportationFeatures">
        <v-card link :to="{ name: 'packages' }" :disabled="subscriptionExpired" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-package-variant</v-icon>
            <div class="text-h6">Συσκευασίες</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Product Categories (Sales Features) -->
      <v-col cols="12" sm="6" md="4" lg="3" v-if="showSalesFeatures">
        <v-card link :to="{ name: 'product-categories' }" :disabled="subscriptionExpired" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-shape</v-icon>
            <div class="text-h6">Κατηγορίες προϊόντων</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Products (Sales Features) -->
      <v-col cols="12" sm="6" md="4" lg="3" v-if="showSalesFeatures">
        <v-card link :to="{ name: 'products' }" :disabled="subscriptionExpired" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-cube-outline</v-icon>
            <div class="text-h6">Προϊόντα</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Pricelists (Sales Features) -->
      <v-col cols="12" sm="6" md="4" lg="3" v-if="showSalesFeatures">
        <v-card link :to="{ name: 'pricelists' }" :disabled="subscriptionExpired" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-tag-multiple</v-icon>
            <div class="text-h6">Τιμοκατάλογοι</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Expense Templates (Menu 8.1) -->
      <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('8.1')">
        <v-card link :to="{ name: 'expensetemplates' }" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-file-document-edit</v-icon>
            <div class="text-h6">Πρότυπα εξόδων</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Primer Settings -->
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-card link :to="{ name: 'primer' }" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-file-document-outline</v-icon>
            <div class="text-h6">Ρυθμίσεις Primer</div>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
export default {
  computed: {
    subscriptionExpired() {
      let user = this.$store.state.currentUser.user
      return user ? user.subscription_expired : false
    },
    showTransportationFeatures() {
      let user = this.$store.state.currentUser.user
      return user && user.company.transportation_features === true
    },
    showSalesFeatures() {
      let user = this.$store.state.currentUser.user
      return user && user.company.sales_features === true
    }
  },
  methods: {
    showMenu(menuId) {
      let user = this.$store.state.currentUser.user
      if (!user) return false
      
      let userMenuConfig = user.menu_config
      if (userMenuConfig == null) return true
      if ((userMenuConfig?.length > 1) == false) return true

      return (userMenuConfig.indexOf(menuId) >= 0)
    }
  }
}
</script>
